import { useMemo } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  ListItemText,
} from "@mui/material";

// Stores an array of option ids in answer.value
const SurveyEntry_MultiSelect = ({ question, value, onChange, isDisabled }) => {
  const options = useMemo(() => question?.options || [], [question]);
  const selected = Array.isArray(value) ? value : [];

  const handleChange = (event) => {
    const next = event.target.value || [];
    onChange(next);
  };

  return (
    <Box sx={{ mt: 1 }}>
      <FormControl
        fullWidth
        size="small"
        disabled={isDisabled}
      >
        <Select
          multiple
          value={selected}
          renderValue={(selectedIds) =>
            options
              .filter((opt) => selectedIds.includes(opt.id))
              .map((opt) => opt.name)
              .join(", ")
          }
          onChange={handleChange}
        >
          {options.map((option) => (
            <MenuItem
              key={option.id}
              value={option.id}
            >
              <Checkbox checked={selected.indexOf(option.id) > -1} />
              <ListItemText primary={option.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SurveyEntry_MultiSelect;
